import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getSystemAiFunctions } from 'app/entities/system-ai-function/system-ai-function.reducer';
import { createEntity, getEntity, reset, updateEntity } from './system-ai-prompt.reducer';

export const SystemAiPromptUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const systemAiFunctions = useAppSelector(state => state.systemAiFunction.entities);
  const systemAiPromptEntity = useAppSelector(state => state.systemAiPrompt.entity);
  const loading = useAppSelector(state => state.systemAiPrompt.loading);
  const updating = useAppSelector(state => state.systemAiPrompt.updating);
  const updateSuccess = useAppSelector(state => state.systemAiPrompt.updateSuccess);

  const handleClose = () => {
    navigate(`/system-ai-prompt${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getSystemAiFunctions({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.id !== undefined && typeof values.id !== 'number') {
      values.id = Number(values.id);
    }
    if (values.systemAiFunctionId !== undefined && typeof values.systemAiFunctionId !== 'number') {
      values.systemAiFunctionId = Number(values.systemAiFunctionId);
    }

    const entity = {
      ...systemAiPromptEntity,
      ...values,
      systemAiFunction: systemAiFunctions.find(it => it.id.toString() === values.systemAiFunction?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...systemAiPromptEntity,
          systemAiFunction: systemAiPromptEntity?.systemAiFunction?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tycheApp.systemAiPrompt.home.createOrEditLabel" data-cy="SystemAiPromptCreateUpdateHeading">
            <Translate contentKey="tycheApp.systemAiPrompt.home.createOrEditLabel">Create or edit a SystemAiPrompt</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="system-ai-prompt-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tycheApp.systemAiPrompt.promptText')}
                id="system-ai-prompt-promptText"
                name="promptText"
                data-cy="promptText"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tycheApp.systemAiPrompt.type')}
                id="system-ai-prompt-type"
                name="type"
                data-cy="type"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                id="system-ai-prompt-systemAiFunction"
                name="systemAiFunction"
                data-cy="systemAiFunction"
                label={translate('tycheApp.systemAiPrompt.systemAiFunction')}
                type="select"
              >
                <option value="" key="0" />
                {systemAiFunctions
                  ? systemAiFunctions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/system-ai-prompt" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default SystemAiPromptUpdate;
